import { h } from '@stencil/core';
import voiceState from 'store/voiceState';
import store from 'store';

export default function VoiceModal({ show }: { show: boolean }) {
  const onClose = () => {
    voiceState.isOpen = false;
    store.showFullScreenModal = null;
  };

  return show ? (
    <div id="voice-modal" role="presentation" class="eva-3-modal-fullscreen -show-modal">
      <div class="modal-fullscreen-header">
        <i class="eva-3-icon-cross  modal-fullscreen-close" role="button" tabindex="0" aria-label="Close modal" onClick={() => onClose()} />
      </div>
      <div class="modal-fullscreen-content">
        <div class="voice-modal-container">
          {voiceState.wavRecorder && voiceState.wavStreamPlayer && (
            <chat-animation-voice wavRecorder={voiceState.wavRecorder} wavStreamPlayer={voiceState.wavStreamPlayer} size={250}></chat-animation-voice>
          )}
        </div>
      </div>
    </div>
  ) : null;
}
